import { Stack } from "@mui/material";
import { LargeContentBox, PageTitle } from "../../components/common";
import { PrivateMainLayout } from "../../components/layout";
import { isMobile } from "react-device-detect";
import { Form } from "./components/form";
import { ScreenMobile } from "../../components/common/ScreenMobile";
import { PageHeader } from "@/components/common/PageHeader";
import { FamilyRestroom } from "@mui/icons-material";
import { useState } from "react";

export function Myfamily({ open, onClose }: any) {
  const [auxOpen, setAuxOpen] = useState(isMobile ? true : false);

  const handleClose = () => {
    // setAuxOpen(false);
  };

  return isMobile ? (
    <>
      <ScreenMobile
        title="Minha familia"
        open={open ? open : auxOpen}
        onClose={onClose ? onClose : handleClose}
      >
        <Form />
      </ScreenMobile>
    </>
  ) : (
    <LargeContentBox>
      <Stack sx={{ width: "100%" }} spacing={2}>
        <PageHeader
          title="Minha Família"
          icon={FamilyRestroom}
          description="Cadastre o menor de idade ou dependente e acompanhe resultados de exames, agende consultas e muito mais."
        />
        <Form />
      </Stack>
    </LargeContentBox>
  );
}
